export class BenchmarkProfile {
    name: string;
    badgeUrl: string;
    percent: number;
    behavioralInfo: ProfileBehavioralInfo;

    constructor(obj: any) {
        Object.assign(this, obj);
    }
}

export class ProfileBehavioralInfo {
    aSigma: number;
    bSigma: number;
    cSigma: number;
    dSigma: number;
    description: string;
    expectedBehaviors: string[];
    motivatingNeeds: string[];
    appealingWords: string[];
    primaryBehaviorTrait1: string;
    noteworthyBehaviors1: string[];
    primaryBehaviorTrait2: string;
    noteworthyBehaviors2: string[];
    moreInfoLink: string;

    constructor(obj: any) {
        Object.assign(this, obj);
    }
}
